export default () => ({
  linkContainer: {
    display: 'inline-block',
  },

  textAlign: {
    display: 'flex',
    alignItems: 'center',
  },

  icon: {
    marginRight: '0.5rem',
  },
})
